import React, { useState, useEffect } from "react";
import MyLoader from "../Spinner/MyLoader";
import COLORS from "../resources/colors/COLORS";
import SessionManager from "../Utils/SessionManager";
import { Redirect, useParams, useHistory } from "react-router-dom";
import Iframe from "react-iframe";
import "../css/Admin_css/admin-customize.css";
import Axios from "axios";
import myToast from "../Utils/MyToast";
import BackButton from "../ChildComponent/BackButton";

const FeeReceipt = () => {
  const token = localStorage.getItem("token");
  const [loggedIn] = useState(!!token);
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [showPreview, setShowPreview] = useState(true);
  const [fileUrl, setFileUrl] = useState("");
  const [selectedSamplePosition, setSelectedSamplePosition] = useState(0);
  const [printableSamples, setPrintableSamples] = useState([]);
  const [receiptSettings, setReceiptSettings] = useState([]);
  const [settingsLoading, setSettingsLoading] = useState(false);
  const documentType = "fee_receipt";
  const SETTING_DEFAULT_THERMAL_SAMPLE = "STT009";

  const { transaction_id, session_id, student_id } = useParams();

  useEffect(() => {
    getPrintableSamples();
    getFeeReceiptSettingsData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //Created By Cursor — prefer STT009 default thermal sample when both lists are ready
  useEffect(() => {
    if (!Array.isArray(printableSamples) || printableSamples.length === 0) {
      return;
    }
    const defaultId = (receiptSettings || []).find(
      (s) => s.setting_id === SETTING_DEFAULT_THERMAL_SAMPLE
    )?.setting_value;
    if (!defaultId) {
      return;
    }
    const idx = printableSamples.findIndex(
      (s) => String(s.sample_id) === String(defaultId)
    );
    if (idx >= 0 && idx !== selectedSamplePosition) {
      setSelectedSamplePosition(idx);
      setSample(idx, printableSamples);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [receiptSettings, printableSamples]);

  //Created By Cursor
  const getFeeReceiptSettingsData = async () => {
    try {
      setSettingsLoading(true);
      const SCHOOL_CODE = SessionManager.getSchoolCode();
      const FUNCTION_NAME = "getFeeReceiptSettingsData.php";
      const URL =
        process.env.REACT_APP_SERVER_NAME +
        process.env.REACT_APP_TARGET_DIR +
        FUNCTION_NAME;

      const { data: response } = await Axios.get(URL, {
        params: { school_code: SCHOOL_CODE },
      });

      if (response.api_status === "OK") {
        setReceiptSettings(response.data || []);
      } else {
        myToast.notify_warning(response.api_remark);
      }
    } catch (error) {
      console.error("Error fetching fee receipt settings:", error);
    } finally {
      setSettingsLoading(false);
    }
  };

  //Created By Cursor
  const saveSettingValue = async (setting_id, newValue) => {
    try {
      setSettingsLoading(true);
      const SCHOOL_CODE = SessionManager.getSchoolCode();
      const FUNCTION_NAME = "updateFeeReceiptSetting.php";
      const URL =
        process.env.REACT_APP_SERVER_NAME +
        process.env.REACT_APP_TARGET_DIR +
        FUNCTION_NAME;

      const { data: response } = await Axios.get(URL, {
        params: {
          school_code: SCHOOL_CODE,
          setting_id: setting_id,
          status: newValue,
        },
      });

      if (response.api_status === "OK") {
        setReceiptSettings((prev) =>
          prev.map((s) =>
            s.setting_id === setting_id
              ? { ...s, setting_value: String(newValue) }
              : s
          )
        );
        if (setting_id === SETTING_DEFAULT_THERMAL_SAMPLE) {
          const idx = printableSamples.findIndex(
            (s) => String(s.sample_id) === String(newValue)
          );
          if (idx >= 0) {
            setSelectedSamplePosition(idx);
            setSample(idx);
            return;
          }
        }
        refreshPreview();
      } else {
        myToast.notify_warning(response.api_remark || "Update failed.");
      }
    } catch (error) {
      console.error("Error updating fee receipt setting:", error);
      myToast.notify_error("An error occurred while updating the setting.");
    } finally {
      setSettingsLoading(false);
    }
  };

  //Created By Cursor
  const toggleSetting = (setting_id, setting_value) => {
    const newValue = setting_value === "1" ? "0" : "1";
    saveSettingValue(setting_id, newValue);
  };

  //Created By Cursor
  const refreshPreview = () => {
    setFileUrl((prev) => {
      if (!prev) return prev;
      const base = prev.split("&_ts=")[0];
      return `${base}&_ts=${Date.now()}`;
    });
    setShowPreview(true);
  };

  const getPrintableSamples = () => {
    setLoading(true);
    const schoolCode = SessionManager.getSchoolCode();
    const functionName = "getPrintableSample.php?";
    const url =
      process.env.REACT_APP_SERVER_NAME +
      process.env.REACT_APP_TARGET_DIR +
      functionName;

    Axios.get(url, {
      params: {
        school_code: schoolCode,
        document_type: documentType,
      },
    })
      .then((res) => res.data)
      .then((response) => {
        setLoading(false);
        if (response.api_status === "OK") {
          setPrintableSamples(response.data);
          setSelectedSamplePosition(0);
          setSample(0, response.data);
        } else {
          myToast.notify_warning(response.api_remark);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching samples:", error);
      });
  };

  const setSample = (position, samples = printableSamples) => {
    const sample = samples[position];
    if (!sample) return;

    const fileName = sample.file_name || "";
    const fileDirectory = sample.file_directory || "";
    if (!fileDirectory || !fileName) return;

    const schoolCode = SessionManager.getSchoolCode();
    const url =
      process.env.REACT_APP_SERVER_NAME +
      fileDirectory +
      fileName +
      `?&student_id=${student_id}` +
      `&session_id=${session_id}` +
      `&transaction_id=${transaction_id}` +
      `&system_code=${process.env.REACT_APP_SYSTEM_CODE}` +
      `&school_code=${schoolCode}`;

    setFileUrl(url);
    setShowPreview(true);
    console.log("FILE_URL", url);
  };

  const changeSample = (position) => {
    setSelectedSamplePosition(position);
    setSample(position);
  };

  if (!loggedIn) return <Redirect to="/Login" />;
  if (loading) return <MyLoader />;

  return (
    <div className="content">
      {/* ── Header ── */}
      <div
        className="content-header"
        style={{ background: COLORS.primary_color_shade5 }}
      >
        <div className="leftside-content-header">
          <ul className="breadcrumbs">
            <li>
              <i
                className="fa fa-home"
                aria-hidden="true"
                style={{ color: COLORS.white }}
              />
              <a href="#"> Fee Receipt </a>
            </li>
          </ul>
        </div>
        <div className="rightside-content-header">
          <BackButton onClick={() => history.goBack()} />
        </div>
      </div>

      {/* ── Body card ── */}
      <div
        className="animated fadeInUpn bg_page_white_rounded box_shadow"
        style={{ "--mMargin": "30px", padding: "0px" }}
      >
        {/* Header (PdAdmissionForm-style) */}
        <div
          style={{
            width: "100%",
            background: `linear-gradient(135deg, ${COLORS.primary_color_shade6} 0%, ${COLORS.primary_color_shade8} 100%)`,
            padding: "16px 24px",
            borderRadius: "8px 8px 0 0",
            boxShadow: `0 2px 4px ${COLORS.primary_color_shade3}`,
          }}
        >
          <h3
            style={{
              fontSize: "24px",
              fontWeight: "600",
              color: "#fff",
              margin: 0,
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <i
              className="fa fa-file-text"
              aria-hidden="true"
              style={{ color: "#fff" }}
            />
            Fee Receipt
          </h3>
        </div>
        {/* ── Template picker ── */}
        {printableSamples.length > 0 && (
          <div style={{ padding: "14px 16px 6px" }}>
            <p
              style={{
                fontSize: 12,
                fontWeight: 600,
                color: "#64748b",
                textTransform: "uppercase",
                letterSpacing: "0.05em",
                marginBottom: 10,
              }}
            >
              Select Template
            </p>
            <div className="d-flex flex-wrap" style={{ gap: 16 }}>
              {printableSamples.map((item, index) => {
                const selected = selectedSamplePosition === index;
                return (
                  <div
                    key={index}
                    onClick={() => changeSample(index)}
                    style={{
                      cursor: "pointer",
                      width: 160,
                      borderRadius: 12,
                      border: selected
                        ? `2px solid ${COLORS.primary_color_shade5}`
                        : "2px solid #e2e8f0",
                      background: selected ? COLORS.primary_color_shade0 : "#f8fafc",
                      boxShadow: selected
                        ? `0 2px 10px ${COLORS.primary_color_shade2}55`
                        : "0 1px 3px rgba(0,0,0,0.07)",
                      transition: "all 0.18s ease",
                      overflow: "hidden",
                    }}
                  >
                    <div
                      style={{
                        padding: "18px 8px",
                        textAlign: "center",
                        fontSize: 13.5,
                        fontWeight: selected ? 700 : 500,
                        color: selected ? COLORS.primary_color_shade7 : "#475569",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {item.sample_name}
                    </div>
                    {selected && (
                      <div
                        style={{
                          height: 3,
                          background: COLORS.primary_color_shade5,
                          borderRadius: "0 0 8px 8px",
                        }}
                      />
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {/* ── Receipt settings ── */}
        {receiptSettings.length > 0 && (
          <div style={{ padding: "10px 16px 4px" }}>
            <p
              style={{
                fontSize: 12,
                fontWeight: 600,
                color: "#64748b",
                textTransform: "uppercase",
                letterSpacing: "0.05em",
                marginBottom: 10,
              }}
            >
              Receipt Settings
              {settingsLoading && (
                <i
                  className="fa fa-spinner fa-spin"
                  style={{ marginLeft: 8, color: COLORS.primary_color_shade5 }}
                  aria-hidden
                />
              )}
            </p>
            <div className="d-flex flex-wrap" style={{ gap: 10 }}>
              {receiptSettings
                .filter(
                  (item) =>
                    String(item.setting_type || "").toLowerCase() === "boolean"
                )
                .map((item) => {
                const enabled = item.setting_value === "1";
                return (
                  <div
                    key={item.setting_id}
                    onClick={() =>
                      !settingsLoading &&
                      toggleSetting(item.setting_id, item.setting_value)
                    }
                    style={{
                      cursor: settingsLoading ? "wait" : "pointer",
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 8,
                      padding: "6px 12px",
                      borderRadius: 999,
                      border: enabled
                        ? `1.5px solid ${COLORS.primary_color_shade5}`
                        : "1.5px solid #e2e8f0",
                      background: enabled
                        ? COLORS.primary_color_shade0
                        : "#f8fafc",
                      fontSize: 12.5,
                      fontWeight: enabled ? 700 : 500,
                      color: enabled
                        ? COLORS.primary_color_shade7
                        : "#64748b",
                      userSelect: "none",
                      transition: "all 0.15s ease",
                    }}
                  >
                    <i
                      className={
                        enabled ? "fa fa-toggle-on" : "fa fa-toggle-off"
                      }
                      style={{
                        fontSize: 16,
                        color: enabled
                          ? COLORS.primary_color_shade5
                          : "#94a3b8",
                      }}
                      aria-hidden
                    />
                    {item.setting_name}
                  </div>
                );
              })}
            </div>
            {/* Created By Cursor — Default Thermal Sample ID */}
            {receiptSettings.some(
              (s) => s.setting_id === SETTING_DEFAULT_THERMAL_SAMPLE
            ) ? (
              <div
                style={{
                  marginTop: 12,
                  display: "flex",
                  flexWrap: "wrap",
                  alignItems: "center",
                  gap: 10,
                }}
              >
                <span
                  style={{
                    fontSize: 12.5,
                    fontWeight: 600,
                    color: "#64748b",
                  }}
                >
                  Default Thermal Sample
                </span>
                <select
                  value={
                    receiptSettings.find(
                      (s) => s.setting_id === SETTING_DEFAULT_THERMAL_SAMPLE
                    )?.setting_value || ""
                  }
                  disabled={settingsLoading}
                  onChange={(e) =>
                    saveSettingValue(
                      SETTING_DEFAULT_THERMAL_SAMPLE,
                      e.target.value
                    )
                  }
                  style={{
                    minWidth: 220,
                    padding: "6px 10px",
                    borderRadius: 8,
                    border: "1.5px solid #e2e8f0",
                    fontSize: 13,
                  }}
                >
                  <option value="">— Not set —</option>
                  {printableSamples
                    .filter((s) =>
                      `${s.sample_name || ""} ${s.file_name || ""}`
                        .toLowerCase()
                        .includes("thermal")
                    )
                    .map((s) => (
                      <option key={s.sample_id} value={s.sample_id}>
                        {s.sample_name || s.sample_id}
                      </option>
                    ))}
                </select>
              </div>
            ) : null}
          </div>
        )}

        {/* ── Divider ── */}
        <div style={{ height: 1, background: "#e2e8f0", margin: "12px 16px" }} />

        {/* ── Preview label ── */}
        <div style={{ padding: "0 16px 8px", display: "flex", alignItems: "center", gap: 8 }}>
          <i className="fa fa-eye" style={{ color: COLORS.primary_color_shade5, fontSize: 16 }} />
          <span style={{ fontWeight: 600, fontSize: 15, color: "#334155" }}>Preview</span>
        </div>

        {/* ── Iframe with overlay loader ── */}
        <div
          style={{
            margin: "0 16px 20px",
            borderRadius: 10,
            overflow: "hidden",
            border: `1px solid ${COLORS.primary_color_shade2}`,
            position: "relative",
            minHeight: 320,
          }}
        >
          {showPreview && (
            <div
              style={{
                position: "absolute",
                inset: 0,
                zIndex: 2,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "rgba(255,255,255,0.88)",
              }}
              aria-busy="true"
            >
              <MyLoader />
            </div>
          )}
          <Iframe
            url={fileUrl}
            width="100%"
            height="1300px"
            id="iFrameStudentId"
            frameBorder="0"
            display="initial"
            position="relative"
            onLoad={() => setShowPreview(false)}
          />
        </div>
      </div>
    </div>
  );
};

export default FeeReceipt;
